
export { removeNullishItems } from "/opt/atlassian/pipelines/agent/build/packages/modules/module-core/src/utils/index.ts"